import { supabase } from "@/lib/supabase/supabaseClient";
import { DeleteOrganizationProps } from ".";

export const deleteOrganization = async ({orgId}: DeleteOrganizationProps) => await supabase.from('organisation').delete().eq('id', orgId).select().maybeSingle().throwOnError().then(res => res.data);